import React from "react";
import { Outlet } from "react-router-dom";
import Navbar from "./Navbar";

const Footer = () => (
  <footer className="bg-acf-blue text-white py-12 mt-auto">
    <div className="max-w-7xl mx-auto px-4 text-center">
      <h4 className="font-primary text-2xl mb-4 tracking-widest">
        ACF LUXURY STAYS
      </h4>
      <p className="font-secondary text-sm text-gray-300 mb-8">
        TELLURIDE, CO | BEAVER CREEK, CO | DENVER, CO | DEL MAR, CA | MIAMI BEACH, FL
      </p>
      <div className="flex justify-center space-x-6 mb-8 text-sm font-secondary">
        <a
          href="/homes"
          className="hover:text-acf-gold text-white no-underline"
        >
          Homes
        </a>
        <a
          href="/about"
          className="hover:text-acf-gold text-white no-underline"
        >
          About
        </a>
        <a
          href="/team"
          className="hover:text-acf-gold text-white no-underline"
        >
          Meet the Team
        </a>
        <a
          href="/contact"
          className="hover:text-acf-gold text-white no-underline"
        >
          Contact
        </a>
      </div>
      <p className="text-xs text-gray-500 font-secondary">
        &copy; {new Date().getFullYear()} ACF Luxury Stays. All rights reserved.
      </p>
    </div>
  </footer>
);

const Layout = () => {
  return (
    <div className="flex flex-col min-h-screen">
      <Navbar />
      <main className="flex-grow">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};

export default Layout;
